import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/light/copy.svg'
import BaseIcon from '../../BaseIcon'

const Copy = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 448 512" />
}

Copy.propTypes = {
	className: PropTypes.string,
}

export default Copy
